/** Cross-module session signals (axios is outside React). */

const SUCCESS = 'auth:api-success';
const EXPIRED = 'auth:session-expired';

export function emitApiSuccess() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SUCCESS));
}

export function emitSessionExpired() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EXPIRED));
}

export function onApiSuccess(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(SUCCESS, handler);
  return () => window.removeEventListener(SUCCESS, handler);
}

export function onSessionExpired(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EXPIRED, handler);
  return () => window.removeEventListener(EXPIRED, handler);
}
